export const SCHEDULE_ADD_URL         = 'schedule/save'
export const SCHEDULE_ADD_ERROR       = 'SCHEDULE_ADD_ERROR'
export const SCHEDULE_ADD_LOADING     = 'SCHEDULE_ADD_LOADING'
export const SCHEDULE_ADD_SUCCESS     = 'SCHEDULE_ADD_SUCCESS'

export const SCHEDULE_PAGE_URL         = 'schedule/page'
export const SCHEDULE_PAGE_ERROR       = 'SCHEDULE_PAGE_ERROR'
export const SCHEDULE_PAGE_LOADING     = 'SCHEDULE_PAGE_LOADING'
export const SCHEDULE_PAGE_SUCCESS     = 'SCHEDULE_PAGE_SUCCESS'

export const SCHEDULE_LIST_URL         = 'schedule/list'
export const SCHEDULE_LIST_ERROR       = 'SCHEDULE_LIST_ERROR'
export const SCHEDULE_LIST_LOADING     = 'SCHEDULE_LIST_LOADING'
export const SCHEDULE_LIST_SUCCESS     = 'SCHEDULE_LIST_SUCCESS'

export const SCHEDULE_VIEW_URL         = 'schedule/view'
export const SCHEDULE_VIEW_ERROR       = 'SCHEDULE_VIEW_ERROR'
export const SCHEDULE_VIEW_LOADING     = 'SCHEDULE_VIEW_LOADING'
export const SCHEDULE_VIEW_SUCCESS     = 'SCHEDULE_VIEW_SUCCESS'

export const SCHEDULE_UPDATE_URL         = 'schedule/update'
export const SCHEDULE_UPDATE_ERROR       = 'SCHEDULE_UPDATE_ERROR'
export const SCHEDULE_UPDATE_LOADING     = 'SCHEDULE_UPDATE_LOADING'
export const SCHEDULE_UPDATE_SUCCESS     = 'SCHEDULE_UPDATE_SUCCESS'

export const SCHEDULE_UPDATE_QUOTA_URL         = 'schedule/update_quota'
export const SCHEDULE_UPDATE_QUOTA_ERROR       = 'SCHEDULE_UPDATE_QUOTA_ERROR'
export const SCHEDULE_UPDATE_QUOTA_LOADING     = 'SCHEDULE_UPDATE_QUOTA_LOADING'
export const SCHEDULE_UPDATE_QUOTA_SUCCESS     = 'SCHEDULE_UPDATE_QUOTA_SUCCESS'

export const SCHEDULE_DELETE_URL         = 'schedule/delete'
export const SCHEDULE_DELETE_ERROR       = 'SCHEDULE_DELETE_ERROR'
export const SCHEDULE_DELETE_LOADING     = 'SCHEDULE_DELETE_LOADING'
export const SCHEDULE_DELETE_SUCCESS     = 'SCHEDULE_DELETE_SUCCESS'

export const SCHEDULE_UPDATE_ACTUAL_URL         = 'schedule/update_actual'
export const SCHEDULE_UPDATE_ACTUAL_ERROR       = 'SCHEDULE_UPDATE_ACTUAL_ERROR'
export const SCHEDULE_UPDATE_ACTUAL_LOADING     = 'SCHEDULE_UPDATE_ACTUAL_LOADING'
export const SCHEDULE_UPDATE_ACTUAL_SUCCESS     = 'SCHEDULE_UPDATE_ACTUAL_SUCCESS'

export const SCHEDULE_VALIDATION_QUOTA_URL         = 'schedule/approve'
export const SCHEDULE_VALIDATION_QUOTA_ERROR       = 'SCHEDULE_VALIDATION_QUOTA_ERROR'
export const SCHEDULE_VALIDATION_QUOTA_LOADING     = 'SCHEDULE_VALIDATION_QUOTA_LOADING'
export const SCHEDULE_VALIDATION_QUOTA_SUCCESS     = 'SCHEDULE_VALIDATION_QUOTA_SUCCESS'